var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Sales',{attrs:{"items":_vm.elements,"loading":_vm.loading && _vm.isEmpty},on:{"reached-bottom":_vm.loadMore,"client-clicked":function($event){return _vm.goToClient($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }